<template>
  <div>
    <div>
      <span class="xbed-sub-title">清洁单类型管理</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>麗家会</BreadcrumbItem>
        <BreadcrumbItem>清洁单类型管理</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Tabs class="tabs">
      <TabPane label="清洁类型列表" name="typeList" ref="typeList">
        <Form @submit.native.prevent="preventSubmit" :model="typeListForm" inline>
          <FormItem prop="keyword" label="查询：" :label-width="84">
            <Input type="text" v-model="typeListForm.keyword"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="openEditCleanTypeModal">新增清洁类型</Button>
          </FormItem>
        </Form>
        <Table stripe :loading="typeList.loading" :columns="typeListColumns" :data="typeList.data"></Table>
        <div style="float: left;margin: 10px;overflow: hidden">
          <Page show-sizer placement="top" :total="typeList.count" :current="typeList.page" :page-size="typeList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
        </div>
      </TabPane>
    </Tabs>

    <Modal v-model="cleanItemModal.display" title="清洁项目配置" ref="cleanItemModal" :width="1000" :loading="true" @on-ok="preEditCleanItem">
      <step-selector
        :data="cleanItemModal.itemList"
        :target-items="cleanItemModal.targetItems"
        :titles="cleanItemModal.titles"
        @onChange="changeCleanItem" />
    </Modal>

    <Modal v-model="checkItemModal.display" title="核查项目设置" ref="checkItemModal" :width="1000" :loading="true" @on-ok="preEditCheckItem">
      <step-selector
        :data="checkItemModal.itemList"
        itemType="detail"
        :target-items="checkItemModal.targetItems"
        :titles="checkItemModal.titles"
        @onChange="changeCheckItem" />
      <div slot="footer">
        <span class="selected-target-item-text">已选 {{checkItemModal.targetItems.length}} 个核查项目</span>
        <Button type="default" @click="() => { checkItemModal.display = false }">关闭</Button>
        <Button type="primary" @click="preEditCheckItem">确定</Button>
      </div>
    </Modal>

    <Modal v-model="editCleanTypeModal.display" ref="editCleanTypeModal" :title="editCleanTypeModal.title" :loading="true" @on-ok="preEditCleanType" >
      <Form @submit.native.prevent="preventSubmit" ref="editCleanTypeModalForm" :rules="editCleanTypeModal.rules" :model="editCleanTypeModal" :label-width="98">
        <FormItem v-if="editCleanTypeModal.id" label="类型编号：">
          <span>{{editCleanTypeModal.id}}</span>
        </FormItem>
        <FormItem prop="name" label="类型名称：">
          <Input type="text" v-model="editCleanTypeModal.name"></Input>
        </FormItem>
        <FormItem prop="itemType" label="物品要求：">
          <Select v-model="editCleanTypeModal.itemType" transfer>
            <Option :value="1">固定配置</Option>
            <Option :value="2">建单时人工配置</Option>
          </Select>
        </FormItem>
        <FormItem v-show="editCleanTypeModal.itemType === 1" label="选择物品：">
          <CheckboxGroup v-model="editCleanTypeModal.itemDetail">
            <Checkbox :label="1">
              <span>更换床品</span>
            </Checkbox>
            <Checkbox :label="2">
              <span>更换毛巾</span>
            </Checkbox>
            <Checkbox :label="3">
              <span>补充易耗品</span>
            </Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem label="备注：">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="editCleanTypeModal.description"></Input>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
import Utils from "@/utils";
import API from "@/api";
import StepSelector from "@/components/step-selector";
import {STORE_KEY} from "../../constants"

export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });

    this.queryCleanCheckList();
    this.queryCleanStepList();

    this.queryListForCleanType();
  },
  data() {
    const validateTypeList = {
      name: (rule, value, callback) => {
        if (!this.editCleanTypeModal.name) {
          callback(new Error('请填写类型名称'))
        } else {
          callback();
        }
      }
    }

    return {
      checkList: [],
      stepList: [],
      typeListForm: {
        keyword: ""
      },
      typeListColumns: [
        {
          title: "类型编号",
          key: "id",
          align: "center",
          width: 150
        },
        {
          title: "类型名称",
          key: "name",
          align: "center",
          width: 150
        },
        {
          title: "物品核查项目",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.openCheckItemModal(params.row);
                  }
                }
              },
              "核查设置"
            );
          }
        },
        {
          title: "清洁步骤项目",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h(
              "Button",
              {
                props: {
                  type: "primary",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.openCleanItemModal(params.row);
                  }
                }
              },
              "步骤设置"
            );
          }
        },
        {
          title: "物品要求（布草耗品）",
          align: "center",
          width: 250,
          render: (h, params) => {
            const itemDetailStr = ['更换床品', '更换毛巾', '补充易耗品'];
            let itemDetailTxt = '';
            let itemDetailArr = params.row.itemDetail ? params.row.itemDetail.split(",") : [];
            if (itemDetailArr.length === 0) {

              itemDetailTxt = params.row.itemType === 2 ? '人工配置' : '不更换布草耗品';
            } else {

              let itemDetailStrArr = [];
              for (let i=0; i<itemDetailArr.length; i++) {
                itemDetailStrArr.push(itemDetailStr[+(itemDetailArr[i])-1]);
              }

              itemDetailTxt = itemDetailStrArr.join(',');
            }
            
            return h('div', {}, itemDetailTxt);
          }
        },
        {
          title: "备注",
          key: "description",
          align: "center",
          width: 150
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: '8px'
                  },
                  on: {
                    click: () => {
                      let itemDetail = [];

                      if (params.row.itemDetail) {
                        itemDetail = params.row.itemDetail.split(',').map((item) => {
                          return +item
                        })
                      }

                      const payload = {
                        title: '修改清洁类型',
                        id: params.row.id,
                        name: params.row.name,
                        itemType: params.row.itemType,
                        itemDetail: itemDetail,
                        description: params.row.description
                      }
                      this.openEditCleanTypeModal(payload);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      const payload = {
                        id: params.row.id,
                        name: params.row.name,
                      }
                      this.preDelCleanType(payload);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      typeList: {
        loading: false,
        data: [],
        count: 0,
        page: 1,
        pageSize: 10
      },
      editCleanTypeModal: {
        display: false,
        title: '',
        id: '',
        name: '',
        itemType: 1,
        itemDetail: [1, 2, 3],
        description: '',
        rules: {
          name: [
            { required: true, validator: validateTypeList.name, trigger: 'blur' }
          ]
        },
      },
      cleanItemModal: {
        display: false,
        id: '',
        itemList: [],
        targetItems: [],
        titles: ["清洁项目与步骤", "候选清洁项目"]
      },
      checkItemModal: {
        display: false,
        id: '',
        itemList: [],
        targetItems: [],
        titles: ["已选项目", "可选项目"]
      },
      operation: {
        add: "add",
        remove: "remove"
      }
    };
  },
  methods: {
    changePage(pageIndex) {
      this.typeList.page = pageIndex;
      this.queryListForCleanType();
    },
    changePageSize(pageSize) {
      this.typeList.page = 1;
      this.typeList.pageSize = pageSize;
      this.queryListForCleanType();
    },
    async queryCleanCheckList() {
      let params = {page: 1, pageSize: 999999}

      const resp = (await API.omsAPI[this.env].cleaner.cleanCheckList(params, this.token)).data

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询核查项目列表失败",
          desc: resp.msg
        });
        return
      }

      this.checkList = resp.content.map((item) => {
        item.label = item.name;

        // 生成核查项目的详情
        item.stepDetail = [];
        if (item.type === 2 && item.detail) {

          item.stepDetail = JSON.parse(item.detail);
        } else if (item.type === 1 && item.goodsDetail) {
          
          item.stepDetail = JSON.parse(item.goodsDetail);
        }

        return item
      })
    },
    async queryCleanStepList() {
      let params = {page: 1, pageSize: 999999}

      const resp = (await API.omsAPI[this.env].cleaner.cleanStepList(params, this.token)).data

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询项目列表列表失败",
          desc: resp.msg
        });
        return
      }

      this.stepList = resp.content.map((item) => {
        item.label = item.name;
        return item
      })
    },
    async queryListForCleanType() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanType_list')) {
        return;
      }

      let params = {page: this.typeList.page, pageSize: this.typeList.pageSize}
      if (this.typeListForm.keyword) {
        params.search = this.typeListForm.keyword
      }

      const resp = (await API.omsAPI[this.env].cleaner.queryListForCleanType(params, this.token)).data

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询清洁类型列表失败",
          desc: resp.msg
        });
        return
      }

      this.typeList.data = resp.content;
      this.typeList.count = resp.totalCount;
    },
    openEditCleanTypeModal(payload={}) {
      this.initEditCleanTypeModal(payload);

      this.editCleanTypeModal.display = true;
    },
    initEditCleanTypeModal(payload) {
      this.editCleanTypeModal = Object.assign(this.editCleanTypeModal, {
        title: '新增清洁类型',
        id: '',
        name: '',
        itemType: 1,
        itemDetail: [1, 2, 3],
        description: ''
      }, payload)
    },
    async preEditCleanType() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanType_edit')) {
        this.$refs.editCleanTypeModal.buttonLoading = false;
        return;
      }

      let validResult = false;
      this.$refs.editCleanTypeModalForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.editCleanTypeModal.buttonLoading = false;
        return;
      }

      let params = {
        name: this.editCleanTypeModal.name,
        itemType: this.editCleanTypeModal.itemType,
      }

      this.editCleanTypeModal.itemType === 1 && this.editCleanTypeModal.itemDetail.length > 0 && (params.itemDetail = this.editCleanTypeModal.itemDetail.join(','))
      this.editCleanTypeModal.description && (params.description = this.editCleanTypeModal.description);

      let apiName = '';
      if (this.editCleanTypeModal.id) {
        
        params.id = this.editCleanTypeModal.id;
        params.used = 1;
        params.updateName = this.username;

        apiName = 'editCleanType'
      } else {

        params.createName = this.username;

        apiName = 'addCleanType'
      }

      const resp = (await API.omsAPI[this.env].cleaner[apiName](params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "操作失败",
          desc: resp.msg
        });
        this.$refs.editCleanTypeModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "操作成功"
      });
      this.queryListForCleanType();
      this.editCleanTypeModal.display = false;
    },
    preDelCleanType(payload) {
      this.$Modal.confirm({
        render: h => {
          let delText = `确定删除 ${ payload.id } - ${ payload.name } 吗？\n一经确定将无法修改`;
          return h("div", {
            style: {
              fontSize: "16px",
            },
          }, delText)
        },
        onOk: () => {
          this.delCleanType(payload);
        }
      })
    },
    async delCleanType(payload) {
      if (!this.checkHasPermission('oms_xbclean_xbCleanType_del')) {
        return;
      }
      
      const params = {
        name: payload.name,
        id: payload.id,
        used: 0,
        updateName: this.username
      }

      const resp = (await API.omsAPI[this.env].cleaner.editCleanType(params, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "操作失败",
          desc: resp.msg
        });
        return
      } 

      this.$Notice.success({
        title: "操作成功"
      });
      this.queryListForCleanType();
    },
    async openCleanItemModal(cleanTypeItem) {
      this.initCleanItemModal(cleanTypeItem);

      const resp = (await API.omsAPI[this.env].cleaner.queryListObjectForCleanType(cleanTypeItem.id, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询清洁步骤项目失败",
          desc: resp.msg
        });
        return
      }

      this.cleanItemModal.targetItems = resp.map((item) => {
        item.label = item.cleanObjectName
        return item;
      })

      this.cleanItemModal.display = true;
      
    },
    initCleanItemModal(cleanTypeItem) {
      this.cleanItemModal = Object.assign(this.cleanItemModal, {
        id: cleanTypeItem.id,
        itemList: JSON.parse(JSON.stringify(this.stepList)),
        targetItems: [],
      })
    },
    async preEditCleanItem() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanType_editObject')) {
        this.$refs.cleanItemModal.buttonLoading = false;
        return;
      }

      const param = this.cleanItemModal.targetItems.map((item, index) => {
        return {
          cleanObjectId: item.cleanObjectId ? item.cleanObjectId : item.id,
          cleanTypeId: this.cleanItemModal.id,
          createName: this.username,
          orderNum: index+1
        };
      });

      const resp = (await API.omsAPI[this.env].cleaner.editObjectForCleanType(JSON.stringify(param), this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "编辑失败",
          desc: resp.msg
        });
        this.$refs.cleanItemModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "编辑成功"
      });

      this.queryListForCleanType();
      this.cleanItemModal.display = false;

    },
    changeCleanItem(changeArgs) {
      const {operation, item, index} = changeArgs

      if (operation === this.operation.add) {

        if (this.cleanItemModal.targetItems.length === 20) {
          this.$Notice.error({
            title: "提示信息 清洁项目跟步骤不得超过20个"
          });
          return;
        }

        this.cleanItemModal.targetItems.push(item);
      } else if (operation === this.operation.remove) {

        this.cleanItemModal.targetItems.splice(index, 1);
      }

    },
    async openCheckItemModal(cleanTypeItem) {
      this.initCheckItemModal(cleanTypeItem);

      const resp = (await API.omsAPI[this.env].cleaner.queryListCheckObject(cleanTypeItem.id, this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询核查项目列表失败",
          desc: resp.msg
        });
        return
      }

      this.checkItemModal.targetItems = resp.map((item) => {
        item.label = item.checkName

        for (let i=0; i<this.checkItemModal.itemList.length; i++) {
          if (item.checkObjectId === this.checkItemModal.itemList[i].id) {
            this.checkItemModal.itemList.splice(i, 1);
            break;
          }
        }

        // 生成核查项目的详情
        item.stepDetail = [];
        if (item.type === 2 && item.detail) {

          item.stepDetail = JSON.parse(item.detail);
        } else if (item.type === 1 && item.goodsDetail) {
          
          item.stepDetail = JSON.parse(item.goodsDetail);
        }

        return item;
      })

      this.checkItemModal.display = true;
      
    },
    initCheckItemModal(cleanTypeItem) {
      this.checkItemModal = Object.assign(this.checkItemModal, {
        id: cleanTypeItem.id,
        itemList: JSON.parse(JSON.stringify(this.checkList)),
        targetItems: [],
      })
    },
    changeCheckItem(changeArgs) {
      const {operation, item, index} = changeArgs

      if (operation === this.operation.add) {

        this.checkItemModal.targetItems.push(item);
        this.checkItemModal.itemList.splice(index, 1);
      } else if (operation === this.operation.remove) {

        let smallerIndex = -1;
        for (let i=0; i<this.checkItemModal.itemList.length; i++) {
          const id = this.checkItemModal.itemList[i].checkObjectId ? this.checkItemModal.itemList[i].checkObjectId : this.checkItemModal.itemList[i].id;
          const changeItemId = item.checkObjectId ? item.checkObjectId : item.id;
          if (id < changeItemId) {
            smallerIndex = i;
            break;
          }
        }

        if (smallerIndex === -1) {
          this.checkItemModal.itemList.push(item);
        } else {
          this.checkItemModal.itemList.splice(smallerIndex, 0, item);
        }
        
        this.checkItemModal.targetItems.splice(index, 1);
      }

    },
    async preEditCheckItem() {
      if (!this.checkHasPermission('oms_xbclean_xbCleanType_editCheckObject')) {
        this.$refs.checkItemModal.buttonLoading = false;
        return;
      }

      const param = this.checkItemModal.targetItems.map((item, index) => {
        const checkObjectId = item.checkObjectId ? item.checkObjectId : item.id
        return {
          checkObjectId,
          cleanTypeId: this.checkItemModal.id,
          createName: this.username,
          orderNum: index+1
        };
      });

      const resp = (await API.omsAPI[this.env].cleaner.editCheckObject(JSON.stringify(param), this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "编辑失败",
          desc: resp.msg
        });
        this.$refs.checkItemModal.buttonLoading = false;
        return
      }

      this.$Notice.success({
        title: "编辑成功"
      });

      this.queryListForCleanType();
      this.checkItemModal.display = false;

    },
    // 权限校验
    checkHasPermission(name) {
      if(!Utils.hasPermission(name)){
        this.$Notice.error({
          title: Utils.getFromStore(STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS)
        });

        return false;
      }
      return true;
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    }
  },
  components: {
    "step-selector": StepSelector
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-top: 20px;
}
.selected-target-item-text{
  margin-right: 12px;
}
</style>




// WEBPACK FOOTER //
// src/pages/cleaner/type-list.vue